import React, { useEffect, useState, useCallback } from 'react';
import MInfiniteScroll from '@/components/ui/atoms/MInfiniteScroll';

interface PostItemProps {
  post: Post;
  idx: number;
}

const PostItem: React.FC<PostItemProps> = ({ post, idx }) => (
  <div
    style={{
      padding: '18px 20px',
      borderBottom: '1px solid #f1f1f1',
      background: idx % 2 === 0 ? '#fcfcfc' : '#fff',
    }}
  >
    <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 4 }}>{post.title}</div>
    <div style={{ color: '#444', fontSize: 15 }}>{post.body}</div>
    <div style={{ fontSize: 13, color: '#888', marginTop: 6 }}>
      Post #{post.id} by User {post.userId}
    </div>
  </div>
);

// We'll use JSONPlaceholder for demo: https://jsonplaceholder.typicode.com/posts
const PAGE_SIZE = 10;

interface Post {
  userId: number;
  id: number;
  title: string;
  body: string;
}

const fetchPosts = async (page: number, limit: number): Promise<Post[]> => {
  const res = await fetch(
    `https://jsonplaceholder.typicode.com/posts?_page=${page}&_limit=${limit}`
  );
  return res.json();
};

const MInfiniteScrollTest: React.FC = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchNextPage = useCallback(async () => {
    if (isLoading) return;
    setIsLoading(true);
    setError(null);
    try {
      const newPosts = await fetchPosts(page, PAGE_SIZE);
      setPosts((prev) => [...prev, ...newPosts]);
      setPage((prev) => prev + 1);
      if (newPosts.length < PAGE_SIZE) setHasMore(false);
    } catch (e) {
      setError('Failed to fetch posts.');
    } finally {
      setIsLoading(false);
    }
  }, [isLoading, page]);

  // Initial load
  useEffect(() => {
    fetchNextPage();
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ maxWidth: 500, margin: '40px auto', padding: 24 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 16 }}>MInfiniteScroll Demo</h1>
      <p style={{ color: '#666', marginBottom: 32 }}>
        Scroll to load more posts from <code>jsonplaceholder.typicode.com</code>. Click the floating Top button to quickly return to the top.
      </p>
      <div style={{ border: '1px solid #eee', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <MInfiniteScroll
          data={posts}
          hasMore={hasMore}
          isLoading={isLoading}
          onLoadMore={fetchNextPage}
          renderItem={(post: Post, idx: number) => <PostItem post={post} idx={idx} key={post.id} />}
        />


        {error && (
          <div style={{ color: 'red', textAlign: 'center', padding: 12 }}>{error}</div>
        )}
        {!hasMore && !isLoading && (
          <div style={{ color: '#888', textAlign: 'center', padding: 16 }}>No more posts to load.</div>
        )}
      </div>
    </div>
  );
};

export default MInfiniteScrollTest;
